import React from 'react'
import {Icon} from '@chakra-ui/react'

const EmailIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                d="M25.8919 23.0035L41.3337 10.6607C41.7478 10.3296 42.3519 10.397 42.683 10.8111C43.014 11.2253 42.9466 11.8294 42.5325 12.1604L27.0637 24.5241C25.2225 25.8915 22.372 25.8915 20.66 24.5033L5.21697 12.1605C4.80281 11.8294 4.73541 11.2253 5.06643 10.8112C5.39745 10.397 6.00154 10.3296 6.4157 10.6606L21.864 23.0077C22.8867 23.837 24.7687 23.837 25.8919 23.0035Z"
                fill="currentColor"
            />
            <path
                d="M6.36806 36.9011L16.7049 26.6565C17.0815 26.2833 17.0842 25.6754 16.711 25.2988C16.3378 24.9223 15.73 24.9195 15.3534 25.2928L5.01652 35.5373C4.63994 35.9105 4.63721 36.5184 5.01043 36.895C5.38365 37.2715 5.99148 37.2743 6.36806 36.9011Z"
                fill="currentColor"
            />
            <path
                d="M32.2687 25.2887L42.7301 35.5333C43.1089 35.9043 43.1152 36.5121 42.7443 36.8909C42.3733 37.2697 41.7655 37.276 41.3867 36.9051L30.9253 26.6605C30.5465 26.2896 30.5401 25.6817 30.9111 25.3029C31.282 24.9241 31.8898 24.9178 32.2687 25.2887Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 37.7006C0 40.0841 1.92621 41.9932 4.32259 41.9932H43.3038C45.7002 41.9932 47.6264 40.0841 47.6264 37.7006V10.0526C47.6264 7.66902 45.7002 5.76001 43.3038 5.76001H4.32259C1.92621 5.76001 0 7.66902 0 10.0526V37.7006ZM1.92 37.7006V10.0526C1.92 8.73328 2.98276 7.68001 4.32259 7.68001H43.3038C44.6436 7.68001 45.7064 8.73328 45.7064 10.0526V37.7006C45.7064 39.0199 44.6436 40.0732 43.3038 40.0732H4.32259C2.98276 40.0732 1.92 39.0199 1.92 37.7006Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EmailIcon
